(function () {
  'use strict';

  const KEY = 'lf-theme-v3';
  try { localStorage.removeItem('lf-theme'); localStorage.removeItem('lf-theme-v2'); } catch (e) {}

  function setTheme(isDark) {
    if (isDark) {
      document.documentElement.setAttribute('data-lf-theme', 'dark');
      try { localStorage.setItem(KEY, 'dark'); } catch (e) {}
    } else {
      document.documentElement.removeAttribute('data-lf-theme');
      try { localStorage.setItem(KEY, 'light'); } catch (e) {}
    }

    document.querySelectorAll('[data-lf-theme-toggle]').forEach((btn) => {
      btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      btn.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
    });
  }

  function syncToggleState() {
    const isDark = document.documentElement.getAttribute('data-lf-theme') === 'dark';
    document.querySelectorAll('[data-lf-theme-toggle]').forEach((btn) => {
      btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      btn.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
    });
  }

  document.addEventListener('click', (e) => {
    const target = e.target instanceof Element ? e.target : null;
    const btn = target?.closest('[data-lf-theme-toggle]');
    if (!btn) return;

    e.preventDefault();
    const isDark = document.documentElement.getAttribute('data-lf-theme') === 'dark';
    setTheme(!isDark);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncToggleState, { once: true });
  } else {
    syncToggleState();
  }
})();
